module.exports = __webpack_public_path__ + "img/build1.d96bef8d.svg";